import { useContext, useState } from "react";
import icon_plus from "../assets/icons/icon_plus.svg";
import itemService from "../services/ItemService";
import LoadSpiner from "./LoadSpiner";
import { activityContext } from "../pages/Dashboard";
const ActivityNav = () => {
  const { isUpdateActivity, addActivity, isLoading } =
    useContext(activityContext);

  return (
    <div className="w-full flex flex-column items-center justify-between">
      <h1
        data-cy="activity-title"
        className="text-sans font-bold text-black text-base md:text-4xl"
      >
        Activity
      </h1>
      <button
        data-cy="activity-add-button"
        disabled={isUpdateActivity}
        onClick={() => addActivity()}
        className="flex flex-row gap-2 justify-center items-center w-[100px] h-[37px] bg-primary text-[12px] text-white text-sans rounded-[45px] md:w-[159px] md:h-[54px] md:text-lg"
      >
        {isUpdateActivity && isLoading ? (
          <LoadSpiner />
        ) : (
          <>
            <span
              className="h-3 w-3 bg-cover md:h-3.5 md:w-3.5"
              style={{ backgroundImage: `url(${icon_plus})` }}
            ></span>{" "}
            Tambah
          </>
        )}
      </button>
    </div>
  );
};

export default ActivityNav;
